import styles from './FJHistory.module.less';
import FJLocalStore from '../../../../store/FJLocalStore.js';
import FJVerticalScroller from '../../../../common/components/FJScroller/FJVerticalScroller.jsx';
import FJHistoryItemContainer from '../container/FJHistoryItemContainer.jsx';
import PropTypes from 'prop-types';
import FJBlankPanel from '../../../FJMainPreview/FJBlankPanel/FJBlankPanel.jsx';
import NoContentIcon from '../../../../assets/svg/no-content.svg?react';
import FJHeader from './FJHeader.jsx';

const FJHistory = props => {
    const { list, children } = props;
    return (
        <div className={styles.box}>
            <FJHeader title={FJLocalStore._('generate-history')} />
            <div className={styles.content_box}>
                {list.length === 0 && <FJBlankPanel icon={<NoContentIcon />} text={FJLocalStore._('no-history-yet')} />}
                {list.length > 0 && (
                    <FJVerticalScroller className={styles.scroll_box}>
                        <div className={styles.content}>
                            {list.map(item => (
                                <FJHistoryItemContainer key={item.id} info={item} />
                            ))}
                        </div>
                    </FJVerticalScroller>
                )}
            </div>
            {children}
        </div>
    );
};

FJHistory.propTypes = {
    list: PropTypes.array,
    children: PropTypes.node,
};

export default FJHistory;
